import inputRule from './inputRule';
const install = Vue => {
    Vue.directive('input-rule', inputRule);
}

if ( window.Vue ) {
    window['inputRule'] = inputRule;
    Vue.use(install);
}

inputRule.install = install;
export default inputRule;